// Bloomberg terminal-style constants for the Security Operations Center
export const SEC = {
  bg:       '#06080d',
  panel:    '#0b0e15',
  panel2:   '#0e1219',
  header:   '#080b11',
  border:   '#1a2030',
  borderBr: '#1e3a5f',
  t1: '#e8edf5',
  t2: '#8a96a8',
  t3: '#4a5568',
  t4: '#2d3748',
  cyan:     '#00b4d8',
  cyanDim:  '#006d8f',
  cyanGlow: 'rgba(0,180,216,0.15)',
  green:  '#22c55e',
  red:    '#ef4444',
  amber:  '#f59e0b',
};

export function severityColor(severity: 'critical' | 'warning' | 'info' | string) {
  switch (severity) { case 'critical': return SEC.red; case 'warning': return SEC.amber; default: return SEC.cyan; }
}
export function statusColor(status: string) {
  switch (status) { case 'new': return SEC.red; case 'acknowledged': case 'investigating': return SEC.amber; case 'resolved': return SEC.green; default: return SEC.t3; }
}
